"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shipmentStatusIsBefore = exports.shipmentStatusIsAfter = void 0;
const dtos_1 = require("../dtos");
/**
 *
 * @param shipmentStatus current status of shipment
 * @param statusToCompare status to check
 * @returns true if shipmentStatus is ahead statusToCompare else false
 * @example shipmentStatus is READY_TO_SHIP statusToCompare is SUBMITTED the method will return true
 */
const shipmentStatusIsAfter = (shipmentStatus, statusToCompare) => dtos_1.shipmentStatusMap[shipmentStatus] > dtos_1.shipmentStatusMap[statusToCompare];
exports.shipmentStatusIsAfter = shipmentStatusIsAfter;
/**
 *
 * @param shipmentStatus current status of order
 * @param statusToCompare status to check
 * @returns true if shipmentStatus is before statusToCompare else false
 * @example shipmentStatus is READY_TO_SHIP statusToCompare submitted the method will return false
 */
const shipmentStatusIsBefore = (shipmentStatus, statusToCompare) => dtos_1.shipmentStatusMap[shipmentStatus] < dtos_1.shipmentStatusMap[statusToCompare];
exports.shipmentStatusIsBefore = shipmentStatusIsBefore;
//# sourceMappingURL=ShipmentStatusUtils.js.map